export const STC_COOKIE_BANNER_EXPERIMENTS = "stc-cookie-banner-experiments";
export const OPTANON_ALERT_BOX_CLOSED_COOKIE = "OptanonAlertBoxClosed";
export const OPTANON_CONSENT_COOKIE = "OptanonConsent";
export const oneYearInMs = 365 * 24 * 60 * 60 * 1000;
export const oneYearInDays = 365;
export const ONETRUST_CONSENT_CHANGED = "onetrust.consentChanged";
